/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_KlaarInputs */

const nl_planning_vakanties_klaar = /** @type {(inputs: Planning_Vakanties_KlaarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar`)
};

/**

* @param {Planning_Vakanties_KlaarInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_klaar = /** @type {((inputs?: Planning_Vakanties_KlaarInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_KlaarInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_klaar(inputs)
});
export { planning_vakanties_klaar as "planning.vakanties.klaar" }